"use client";

import Link from "next/link";
import { components } from "react-select";
import { formatTo12HourTime } from "@/context/utilities";
import Image from "next/image";
import announcementFallback from "../../public/images/icons/announcements.webp";
import DataNotFound from "../NotFound/DataNotFound";

const Announcement = ({ announcements }) => {
  return (
    <>
      <div className="rbt-dashboard-content bg-color-white rbt-shadow-box">
        <div className="content">
          <div className="section-title">
            <h4 className="rbt-title-style-3">Announcements</h4>
          </div>

          {/* <div className="rbt-dashboard-filter-wrapper">
            <div className="row g-5">
              <div className="col-lg-6">
                <div className="filter-select rbt-modern-select">
                  <span className="select-label d-block">Courses</span>
                  <Select
                    instanceId="sortByAuthor"
                    className="react-select"
                    classNamePrefix="react-select"
                    defaultValue={course}
                    onChange={setCourses}
                    options={courses}
                    closeMenuOnSelect={true}
                    isMulti
                    components={components}
                  />
                </div>
              </div>
              <div className="col-lg-3">
                <div className="filter-select rbt-modern-select">
                  <span className="select-label d-block">Short By</span>
                  <Select
                    instanceId="sortBySelect"
                    className="react-select"
                    classNamePrefix="react-select"
                    defaultValue={sortBy}
                    onChange={setSortBy}
                    options={sortByOptions}
                  />
                </div>
              </div>
              <div className="col-lg-3">
                <div className="filter-select rbt-modern-select">
                  <span className="select-label d-block">Short By Offer</span>
                  <Select
                    instanceId="sortBySelect"
                    className="react-select"
                    classNamePrefix="react-select"
                    defaultValue={sortByOffer}
                    onChange={setSortByOffer}
                    options={sortByOffers}
                  />
                </div>
              </div>
            </div>
          </div> */}

          {/* <hr className="mt--30" /> */}
          {announcements.length === 0 ? (
            <div>
              <DataNotFound
                title="No Announcements"
                image={{
                  alt: "No Announcements Image",
                  width: 140,
                  height: 140,
                  src: announcementFallback,
                }}
              />
            </div>
          ) : (
            <div className="rbt-dashboard-table table-responsive mobile-table-750 mt--30">
              <table className="rbt-table table table-borderless">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Details</th>
                  </tr>
                </thead>
                <tbody>
                  {announcements.map((announce) => {
                    return (
                      <tr key={announce._id}>
                        <th>
                          <span className="h6 mb--5">
                            {new Date(announce.createdAt).toDateString()}
                          </span>
                          <p className="b3">
                            {formatTo12HourTime(announce.createdAt)}
                          </p>
                        </th>
                        <td>
                          <span className="h6 mb--5 rbt-hover-02">
                            {announce.displayName}
                          </span>
                          {announce.link && (
                            <Link target="_blank" href={announce.link}>
                              <p className="b3">Click To view resources</p>
                            </Link>
                          )}
                          <p className="b3">{announce.description}</p>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Announcement;

const ValueContainer = ({ children, ...props }) => {
  const { getValue, hasValue } = props;
  const nbValues = getValue().length;
  if (!hasValue) {
    return (
      <components.ValueContainer {...props}>
        {children}
      </components.ValueContainer>
    );
  }
  return (
    <components.ValueContainer {...props}>
      {`${nbValues} items selected`}
    </components.ValueContainer>
  );
};

const MultiValue = (props) => {
  return "3 Selected";
};
